import { render } from "./Users.vue?vue&type=template&id=476ea712&scoped=true"
import script from "./Users.vue?vue&type=script&lang=ts"
export * from "./Users.vue?vue&type=script&lang=ts"

import "./Users.vue?vue&type=style&index=0&id=476ea712&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-476ea712"

export default script